import { ComponentMeta, Story as GenericStory } from "@storybook/react";
import React from "react";
import KeyValue from "../KeyValue";

type Story = GenericStory<React.ComponentProps<typeof KeyValue>>;

export default {
    title: "Typography/Key Value",
    component: KeyValue,
    args: {
        translatedLabel: "Example label",
        value: "Example value"
    }
} as ComponentMeta<typeof KeyValue>;

const Template: Story = args => <KeyValue {...args}>ExampleLabel</KeyValue>;

export const Default = Template.bind({});

export const ColoredKey = Template.bind({});
ColoredKey.args = {
    keyColor: "text-error-700"
};

export const ColoredValue = Template.bind({});
ColoredValue.args = {
    valueColor: "text-error-700"
};

export const SizeKey = Template.bind({});
SizeKey.args = {
    keySize: "heading-x-small-semibold"
};

export const SizeValue = Template.bind({});
SizeValue.args = {
    valueSize: "heading-x-small-semibold"
};
